export const cacheKeys = {
  getMe: 'getMe',
};
